import {createContext} from "react";
const HotelContext = createContext();
export default HotelContext;